import { Helmet } from "react-helmet-async";

export const DefaultMeta = () => (
  <Helmet>
    <link rel="canonical" href="https://yuvaquest.com/" />
    <title>Yuva Quest | Connect with Culture</title>
    <meta
      name="description"
      content="Yuva Quest helps parents and educators connect kids to Indian culture through engaging quests, stories, and history-based fun."
    />
    <meta
      name="robots"
      content={
        process.env.REACT_APP_MODE === "production"
          ? "index,follow"
          : "noindex,nofollow"
      }
    />
  </Helmet>
);
